import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './agent-result.style';
import Card from './card';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgentResult = _ref => {
  var agentList = _ref.agentList,
    launchEmailEnquiryModal = _ref.launchEmailEnquiryModal,
    sort = _ref.sort,
    statsTitle = _ref.statsTitle;
  return ___EmotionJSX("div", {
    css: styles.resultsPanel
  }, agentList.map(agent => ___EmotionJSX(Card, {
    data: agent,
    cardType: "AGENT",
    launchEmailEnquiryModal: launchEmailEnquiryModal,
    key: agent.agentStaffId,
    sort: sort,
    statsTitle: statsTitle
  })));
};
AgentResult.propTypes = {
  agentList: PropTypes.arrayOf(PropTypes.shape({
    agentStaffId: PropTypes.number.isRequired,
    agentStaffName: PropTypes.string.isRequired,
    agencyId: PropTypes.number,
    agencyName: PropTypes.string,
    state: PropTypes.string,
    agencyPhoto: PropTypes.string,
    agentStaffPhotoSmall: PropTypes.string,
    phone: PropTypes.string,
    emailContactable: PropTypes.bool,
    agentUrl: PropTypes.string,
    jobTitle: PropTypes.string
  })).isRequired,
  launchEmailEnquiryModal: PropTypes.func.isRequired,
  sort: PropTypes.oneOf(['SOLD', 'SOLD_TOTAL', 'RENTED', 'RENTED_TOTAL', 'DEVELOPMENT', 'DEVELOPMENT_TOTAL']).isRequired,
  statsTitle: PropTypes.string.isRequired
};
export default AgentResult;